module.exports = __webpack_public_path__ + "static/media/calendar-week.7e21dd11.svg";